import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { AddressAutocompleteAction } from './address-autocomplete.action';
import { AddressAutocompleteEffects } from './address-autocomplete.effects';

export const initialState: Readonly<Addresses> = {
  addressList: [],
  keyword: '',
};

export const addressAutocompleteFeature = createFeature({
  name: 'addressAutocomplete',
  reducer: createReducer(
    initialState,
    on(AddressAutocompleteAction.setKeyword, (state, { value }) => {
      return { ...state, keyword: value };
    }),
    on(AddressAutocompleteAction.setAddressList, (state, { value }) => {
      return { ...state, addressList: value };
    }),
    on(AddressAutocompleteAction.clearAddressList, (state) => {
      return { ...state, addressList: [] };
    })
  ),
});

export const { selectAddressAutocompleteState, selectAddressList } =
  addressAutocompleteFeature;

export function provideAddressAutocompleteFeature() {
  return makeEnvironmentProviders([
    provideState(addressAutocompleteFeature),
    provideEffects(AddressAutocompleteEffects),
  ]);
}
